var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0004 25.4754C19.8901 25.4754 25.4754 19.8901 25.4754 13.0004C25.4754 6.11064 19.8901 0.525391 13.0004 0.525391C6.11064 0.525391 0.525391 6.11064 0.525391 13.0004C0.525391 19.8901 6.11064 25.4754 13.0004 25.4754ZM12.1004 7.00039V14.5004C12.1004 14.9974 12.5033 15.4004 13.0004 15.4004C13.4974 15.4004 13.9004 14.9974 13.9004 14.5004V7.00039C13.9004 6.50333 13.4974 6.10039 13.0004 6.10039C12.5033 6.10039 12.1004 6.50333 12.1004 7.00039ZM14.0504 18.5504C14.0504 19.1303 13.5803 19.6004 13.0004 19.6004C12.4205 19.6004 11.9504 19.1303 11.9504 18.5504C11.9504 17.9705 12.4205 17.5004 13.0004 17.5004C13.5803 17.5004 14.0504 17.9705 14.0504 18.5504Z",
    fill: "#08081B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationDark);
export default __webpack_public_path__ + "static/media/exclamation-dark.6c96034c083a1ab3006897cad8ec6364.svg";
export { ForwardRef as ReactComponent };